import React, { useState } from 'react'
import { useEffect } from 'react'
import { Row, Col, Table, Button, Accordion, Card, Collapse, FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FetchBoutiqueTransactions, FetchMandatorInfos, FetchArticleTypeImages, FetchDeleteSaleTransaction } from '../../fetcher'
import { ModalComponent } from '../presentational-components/ModalComponent'
import SaleTransaction from './SaleTransaction'
import B2COrderTransaction from './B2COrderTransaction'
import DescriptionTooltip from '../presentational-components/DescriptionTooltip'
import AlertMessage from '../presentational-components/AlertMessage'
import { RenderImage } from '../presentational-components/ImageViewer'
import moment from 'moment'
import 'moment/locale/de'
import { ExportCSV } from '../presentational-components/ExportCSV'
import EnumValueTranslations from '../presentational-components/EnumValueTranslations'
import { useExpandRows, useSortTransactions } from '../presentational-components/tablehooks'
import { DateSelect, StateSelect, useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from '../presentational-components/filterutils'
import LoadingSpinner from '../presentational-components/LoadingSpinner';
import { SalesReport } from './SalesReport'

moment.locale('de')


const SalesBoutique = () => {

    const [transactions, setTransactions] = useState([])
    const [filteredTransactions, setFilteredTransactions] = useState([])
    const [sortedTransactions, setSortedTransactions] = useState([])

    const { sortTransactions } = useSortTransactions(transactions, setSortedTransactions)
    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { filterSaleTransactionsBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const [newTransaction, setNewTransaction] = useState(false)
    const [analysis, setAnalysis] = useState({ "isShowing": false, "dailyReport": false })
    const [salesReportPage, setSalesReportPage] = useState(false)

    const [newB2COrderTransaction, setNewB2COrderTransaction] = useState(false)

    const [taskName, setTaskName] = useState("SalesBoutique unbekannt Task")


    const controller = new AbortController()
    const signal = controller.signal

    const handleSetAnalysis = () => {
        setAnalysis({ "isShowing": !analysis.isShowing, "dailyReport": false })
        setSalesReportPage(false)
        controller.abort()
    }

    const handleSetSalesReport = () => {
        setAnalysis({ "isShowing": false, "dailyReport": false })
        setSalesReportPage(!salesReportPage)
        controller.abort()
    }

    const returnFromNewTransaction = () => {
        setNewTransaction(false)

        reload()
    }

    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }

    const [articleDataReady, setArticleDataToReady] = useState(false)

    const addingImages = (articleTypeImages) => {
        let copiedTransactions = [...transactions]
        articleTypeImages.forEach(image => copiedTransactions.flatMap(x => x.SoldArticles).filter(x => x.ArticleId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setTransactions(copiedTransactions)
        setFilteredTransactions(copiedTransactions)
    }

    useEffect(() => {
        if (analysis.isShowing === true) {
            setTaskName("Die Verkäufe werden geladen")
            FetchBoutiqueTransactions(setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, "SalesBoutique", analysis.dailyReport)
        }
        return () => {
            controller.abort()
        }
    }, [analysis]);

    useEffect(() => {
        if (articleDataReady) {
            setTaskName("Die Bilder werden geladen")
            FetchArticleTypeImages(transactions.flatMap(x => x.SoldArticles).map(x => x.ArticleId.toString()), addingImages, openAlert, "SalesBoutique")
        }
    }, [articleDataReady])

    const reload = () => {
        //if (analysis === true) {
        //    setTaskName("Die Verkäufe werden geladen")
        //    FetchBoutiqueTransactions(setTransactions, setFilteredTransactions, openAlert, setArticleDataToReady, signal, "SalesBoutique",  true)
        //}
        setAnalysis({ "isShowing": true, "dailyReport": true })
    }

    useEffect(() => {
        setFilteredTransactions([...transactions])
        setSortedTransactions([...transactions])
    }, [transactions])

    useEffect(() => {
        let filteredTransactions = filterSaleTransactionsBySearchInput(sortedTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect, "Date")
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect, "Payment")

        setFilteredTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, sortedTransactions])

    const [dayReport, setIsDayReport] = useState(false)
    const isDayReport = () => {
        let dates = [...new Set(filteredTransactions.map(x => x.Date))]
        if (dates.length !== 1) setIsDayReport(false)
        else setIsDayReport(true)
    }

    useEffect(() => {
        isDayReport()
    }, [filteredTransactions])

    const [filterBar, setFilterBar] = useState(false)

    const [transactionSysIdToDelete, setTransactionSysIdToDelete] = useState("")
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const handleShowDeleteModal = () => setShowDeleteModal(true)
    const handleCloseDeleteModal = () => setShowDeleteModal(false)

    const removeSaleTransaction = () => {
        FetchDeleteSaleTransaction(transactionSysIdToDelete, openAlert, reload)
        handleCloseDeleteModal()
    }

    const openRemoveModal = (e, transactionSysId) => {
        e.preventDefault()
        setTransactionSysIdToDelete(transactionSysId)
        handleShowDeleteModal()
    }

    const getCsvData = () => {
        let csvData = []
        filteredTransactions.forEach(y => {
            y.SoldArticles.map(x => {
                let articles = {
                    "Datum": y.Date,
                    "Artikelnr.": x.ArticleIdFaex,
                    "Artikelnr. Designer": x.ArticleNumberDesigner,
                    "Artikelname": x.ArticleName,
                    "Designername": x.DesignerName,
                    "Farbe": x.Colour,
                    "Größe": x.Size,
                    "Anzahl": y.Type !== "Sales" ? (-1) * x.Count : x.Count,
                    "Einzelpreis": x.PriceUnit,
                    "Vk-Preis": x.PriceAtTimeOfSale,
                    "Gesamtpreis": y.Type !== "Sales" ? (-1) * parseFloat(x.Count * parseFloat(x.PriceAtTimeOfSale)) : parseFloat(x.Count * parseFloat(x.PriceAtTimeOfSale))
                }
                csvData.push(articles)
            })
        })
        return (csvData)
    }

    const sum = () => {
        let sum = filteredTransactions.map(x => parseFloat(x.Total)).reduce((a, b) => a + b, 0)
        let dailyTotal = parseFloat(sum).toFixed(2).replace('.', ',') + "€"

        return (dailyTotal)
    }

    if (newTransaction === true) return (<SaleTransaction setNewTransaction={setNewTransaction} reload={returnFromNewTransaction} />)
    else if (newB2COrderTransaction === true) return (<B2COrderTransaction setNewB2CTransaction={setNewB2COrderTransaction} reload={returnFromNewTransaction} />)
    else {

        return (
            <div>
                <div className="tablet-center tablet-saletransactions">
                    <h1 >Verkaufstransaktionen</h1>
                    <div className="flex-linebreak"></div>
                    <Button variant="secondary" className="booking-btn" onClick={() => setNewTransaction(true)}>Neue Buchung</Button>
                    &nbsp;
                    <Button variant="secondary" className="booking-btn" onClick={() => { console.log("setNewB2COrderTransaction"); setNewB2COrderTransaction(true) }}>Neue Bestellung</Button>
                    &nbsp;
                    <Button variant="secondary" className="booking-btn" onClick={() => handleSetAnalysis()}>Transaktionen</Button>
                    &nbsp;
                    <Button variant="secondary" className="booking-btn" onClick={() => handleSetSalesReport()}>Verkaufsauswertung</Button>
                    <div className="flex-linebreak"></div>
                </div>

                {salesReportPage && <SalesReport /> }

                {analysis.isShowing && <div className="tablet-transactions">
                    {analysis.dailyReport ? <h3 >Heutige Verkaufstransaktionen</h3>
                        : <h3>Alle Verkaufstransaktionen</h3>
                    }
                    <FormControl className="globalSearch" as="input" placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                    <Table className="table-sm table-sales-striped-immediate table-width-narrow">
                        <thead className="sticky-table-header">
                            <tr>
                                <th></th>
                                <th>Transaktion ID
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'TransactionSysId')}>&#8593; &#8595;</a>
                                </th>
                                <th>Datum
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Date')}>&#8593; &#8595;</a>
                                </th>
                                <th>Art
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Type')}>&#8593; &#8595;</a>
                                </th>
                                <th>Zahlung
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Payment')}>&#8593; &#8595;</a>
                                </th>
                                <th>Anzahl
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Count')}>&#8593; &#8595;</a>
                                </th>
                                <th>Summe
                                    <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Total')}>&#8593; &#8595;</a>
                                </th>
                                <th className="filterIndicator" onClick={() => setFilterBar(!filterBar)}>&#8711; Filtermenü</th>
                                <th></th>
                            </tr>
                            {filterBar ? <tr>
                                <th></th>
                                <th></th>
                                <th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                                <th></th>
                                <th>{StateSelect([...new Set(transactions.map(x => x.Payment.toString()))], handleStatusSelectChange, statusSelect)}</th>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr> : null}
                        </thead>
                        <tbody>
                            {filteredTransactions.map((transaction) =>
                                <>
                                    <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                        {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                        <td>{transaction.TransactionSysId}</td>
                                        <td>{transaction.Date}</td>
                                        <td>{EnumValueTranslations(transaction.Type)}</td>
                                        <td>{transaction.Payment}</td>
                                        <td className="numberColumn">{transaction.Count}</td>
                                        <td className="numberColumn">{parseFloat(transaction.Total).toFixed(2).replace('.', ',') + "€"}</td>
                                        <td></td>
                                        <td>
                                            <OverlayTrigger className="remove-order-td" placement="bottom" overlay={<Tooltip> Verkauf löschen </Tooltip>}>
                                                <a className="remove-order" href="" onClick={(e) => openRemoveModal(e, transaction.TransactionSysId)} variant="secondary">&#10060;</a>
                                            </OverlayTrigger>
                                        </td>
                                    </tr>

                                    <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                        <td colSpan="6" className="td-nomargin">
                                            <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                                <thead className="sticky-table-header">
                                                    <tr className="salesboutique-childheaderrow">
                                                        <th>Ansicht</th>
                                                        <th>Datum</th>
                                                        <th>Designername</th>
                                                        <th>Artikel ID</th>
                                                        <th>Artikelname</th>
                                                        <th>Größe</th>
                                                        <th>Farbe</th>
                                                        <th>Anzahl</th>
                                                        <th>Einzelpreis</th>
                                                        <th>Preisänderung</th>
                                                        <th>Gesamtpreis</th>
                                                        <th>Zahlung</th>
                                                        <th>Bemerkung</th>
                                                    </tr>
                                                </thead>
                                                {transaction.SoldArticles.map(article =>
                                                    <>
                                                        <tr>
                                                            <td>{RenderImage(article.Image)}</td>
                                                            <td>{transaction.Date}</td>
                                                            <td>{article.DesignerName}</td>
                                                            <td>{article.ArticleIdFaex}</td>
                                                            <td>{article.ArticleName}</td>
                                                            <td>{article.Size}</td>
                                                            <td>{article.Colour}</td>
                                                            <td className="numberColumn">{article.Count}</td>
                                                            <td className="numberColumn">{parseFloat(article.PriceUnit).toFixed(2).replace('.', ',') + "€"}</td>
                                                            <td className="numberColumn">{parseFloat((-1) * (parseFloat(article.PriceUnit) - parseFloat(article.PriceAtTimeOfSale))).toFixed(2).replace('.', ',') + "€"}</td>
                                                            <td className="numberColumn">{parseFloat(article.Count * parseFloat(article.PriceAtTimeOfSale)).toFixed(2).replace('.', ',') + "€"}</td>
                                                            <OverlayTrigger trigger="hover" placement="top" overlay={DescriptionTooltip(article.Remark)}>
                                                                <td className="dropdown-article-description">{article.Remark}</td>
                                                            </OverlayTrigger>
                                                        </tr>
                                                    </>
                                                )}
                                            </div>
                                        </td>
                                    </Collapse>

                                </>
                            )}

                            {/*{dayReport &&*/}
                            {filteredTransactions.length > 0 &&
                                <tr className="salesboutique-mainrow dayReport-row">
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Summe:</td>
                                    <td className="numberColumn">{filteredTransactions.map(x => x.Count).reduce((a, b) => a + b, 0)}</td>
                                    <td className="numberColumn">{sum()}</td>
                                    <td><ExportCSV className="sales-export-btn" csvData={getCsvData()} fileName={"Verkäufe"} /></td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </div>}

                <ModalComponent handleShow={showDeleteModal} handleClose={handleCloseDeleteModal} handleSubmit={removeSaleTransaction}
                    reload={reload} modalTitle="Verkauf löschen" modalBody="Möchten Sie den Verkauf wirklich löschen?" />

                <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} />
                <LoadingSpinner task={taskName} area={"SalesBoutique"} />

            </div>
        )
    }
}

export default SalesBoutique